export default __webpack_public_path__ + "static/placeholderFooter-9a570068f89fed5c7c54f71921dedaf5.png";